export default function Pmedicalhistory(){
return(
<div className="medical-container">

    <h1>Medical history of the patients</h1>

    <input type="serach" placeholder="enter your contact"/>










</div>






)


}